import { useRef } from "react";
import Container from "react-bootstrap/esm/Container";
import Introduction from "../components/Introduction";
import SkillSet from "../components/SkillSet";
import ContactMe from "../ContactMe/ContactMe";
import Footer from "../Footer/Footer";
import Projects from "../ProjectsSection/Projects";

const HomePage = () => {

  const sectionRef = useRef(null);

  const scrollToSection = () => {
    // @ts-ignore
    sectionRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <Introduction scrollToSection={scrollToSection}/>
      <SkillSet/>
      <Projects refProp={sectionRef}/>
      <ContactMe />
      <Footer />
    </>
  )
}

export default HomePage;